import { z } from 'zod';
const email = z.string().trim().toLowerCase().pipe(z.email());
export const loginRequestSchema = z.object({
    /** tenant slug; omitted or null for platform (Super Admin) login */
    tenant: z.string().trim().toLowerCase().min(2).max(63).nullish(),
    email,
    password: z.string().min(1).max(256),
});
export const mfaCodeSchema = z.string().regex(/^\d{6}$/, 'Enter the 6-digit code');
export const mfaVerifyRequestSchema = z.object({
    challengeToken: z.string().min(10),
    code: mfaCodeSchema,
});
export const mfaSetupRequestSchema = z.object({ challengeToken: z.string().min(10) });
export const passwordSchema = z
    .string()
    .min(12, 'Use at least 12 characters')
    .max(256)
    .regex(/[a-z]/, 'Add a lowercase letter')
    .regex(/[A-Z]/, 'Add an uppercase letter')
    .regex(/\d/, 'Add a number');
//# sourceMappingURL=schemas.js.map